import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Div} from 'components/primitives/body';
import {WithConsent} from '../../WithConsent';

class ConsentCheckbox extends React.Component {
    static propTypes = {
        linkToFull: PropTypes.string,
        onChange: PropTypes.func,
        consent: PropTypes.shape({
            revision: PropTypes.string.isRequired,
            shortDescription: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired
        }).isRequired,
        type: PropTypes.string.isRequired
    };

    componentDidMount() {
        this.callOnChange(false);
    }

    handleChange = (e) => {
        const {checked} = e.target;
        this.callOnChange(checked);
    };

    callOnChange = (checked) => {
        this.props.onChange({
            type: this.props.type,
            accepted: checked,
            revision: this.props.consent.revision
        });
    };

    createLink = () => {
        const parts = this.props.consent.shortDescription.split('{link}');
        if (parts.length === 1) {
            return <span>{parts[0]}</span>;
        }

        return (
            <span>
                {parts[0]}
                <a target='_blank' rel='noopener noreferrer' href={this.props.linkToFull}>{this.props.consent.title}</a>
                {parts[1]}
            </span>
        );
    };

    render() {
        return (
            <Div>
                <Label className="checkbox">
                    <Checkbox
                        type="checkbox" name={this.props.type} defaultChecked={false}
                        onChange={(e) => this.handleChange(e)}/>
                    {this.createLink()}
                </Label>
            </Div>
        );
    }
}

export class AcceptConsentCheckbox extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        linkToFull: PropTypes.string,
        onChange: PropTypes.func
    };

    static defaultProps = {
        onChange: () => undefined
    };

    renderAcceptSkeleton = () => {
        return 'Loading...';
    };

    render() {
        return (
            <Wrapper>
                <WithConsent type={this.props.type}>
                    {({loading, consent}) => (
                        loading ?
                            this.renderAcceptSkeleton() :
                            <ConsentCheckbox
                                consent={consent}
                                type={this.props.type}
                                onChange={this.props.onChange}
                                linkToFull={this.props.linkToFull}/>
                    )}
                </WithConsent>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`

`;

const Label = styled.label`
  line-height: 16px;
`;

const Checkbox = styled.input`
  position: relative;
  top: -1px;
`;

export default AcceptConsentCheckbox;
